import { render } from "./userIcon.vue?vue&type=template&id=4d67f608&scoped=true"
import script from "./userIcon.vue?vue&type=script&lang=js"
export * from "./userIcon.vue?vue&type=script&lang=js"

import "./userIcon.vue?vue&type=style&index=0&id=4d67f608&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d67f608"]])

export default __exports__